export const reduxKey = '@@DreamupAnon';
